var REACT_ELEMENT_TYPE;function _jsx(type, props, key, children) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var defaultProps = type && type.defaultProps,childrenLength = arguments.length - 3;if (props || 0 === childrenLength || (props = { children: void 0 }), 1 === childrenLength) props.children = children;else if (childrenLength > 1) {for (var childArray = new Array(childrenLength), i = 0; i < childrenLength; i++) childArray[i] = arguments[i + 3];props.children = childArray;}if (props && defaultProps) for (var propName in defaultProps) void 0 === props[propName] && (props[propName] = defaultProps[propName]);else props || (props = defaultProps || {});return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: void 0 === key ? null : "" + key, ref: null, props: props, _owner: null };}import React, { useEffect } from 'react';
import { connect } from 'react-redux';

import { bindActionCreators } from 'redux';
import { Icon } from "../../UI";
import { Item } from "../../Layout";
import { Collapsible } from "../../App/Collapsible";
import { StickyHeader } from "../../App/StickyHeader";
import RelationshipMetadata from "../../Relationships/components/RelationshipMetadata";
import LoadMoreRelationshipsButton from "../../Relationships/components/LoadMoreRelationshipsButton";

import * as actions from "../../Relationships/actions/actions";





function mapStateToProps(state) {
  const { relationships, library } = state;
  return {
    parentEntity: library.ui.get('selectedDocuments').get(0),
    searchResults: relationships.list.searchResults,
    hubs: relationships.hubs,
    relationTypes: actions.selectRelationTypes(state)
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
  {
    selectConnection: actions.selectConnection,
    parseResults: actions.parseResults
  },
  dispatch);

}

const connector = connect(mapStateToProps, mapDispatchToProps);



const createRightRelationshipGroups = (
rightRelationships,
props,
expanded) =>
{
  const { relationTypes, selectConnection, parentEntity } = props;
  return /*#__PURE__*/(
    _jsx("div", { className: "sidepanel-relationship-right" }, void 0,
    rightRelationships.map((relationship, index) => {
      let header;
      const relationshipTemplateId = relationship.get('template');
      const relationType = relationTypes.find((r) => r._id === relationshipTemplateId);
      if (relationType) {var _relationTypes$find;
        header = relationshipTemplateId ? (_relationTypes$find =
        relationTypes.find((r) => r._id === relationshipTemplateId)) === null || _relationTypes$find === void 0 ? void 0 : _relationTypes$find.name : /*#__PURE__*/

        _jsx(Icon, { icon: "link" });

      }

      const entityRelationships = relationship.get('relationships');
      return /*#__PURE__*/(
        _jsx(Collapsible, {
          header: header,
          className: "sidepanel-relationship-collapsible",
          headerInfo: `(${entityRelationships.size})`,
          collapse: !expanded },
        parentEntity.get('_id').toString() + index.toString(), /*#__PURE__*/

        React.createElement(React.Fragment, null,
        entityRelationships.map((rel, entityRelationshipsIndex) => /*#__PURE__*/
        _jsx("div", {
          className: "sidepanel-relationship-right-entity",

          onClick: () => selectConnection(rel.get('entityData')) }, index.toString() + entityRelationshipsIndex.toString(), /*#__PURE__*/

        _jsx(Item, {
          active: false,
          doc: rel.get('entityData'),
          className: "item-collapsed",
          noMetadata: true }))))));






    })));


};

const renderLabel = (template, relationTypes) =>
template ? /*#__PURE__*/
_jsx("span", { className: "sidepanel-relationship-left-label" }, void 0,
`${relationTypes.find((r) => r._id === template).name}`) : /*#__PURE__*/


_jsx("span", { className: "sidepanel-relationship-left-label" }, void 0, /*#__PURE__*/
_jsx(Icon, { icon: "link" }));



const createLabelGroups = (props, hub, index) => {
  const { relationTypes, expanded, parentEntity } = props;
  const template = hub.getIn(['leftRelationship', 'template']);
  return /*#__PURE__*/(
    _jsx(StickyHeader, {
      scrollElementSelector: ".scrollable",
      stickyElementSelector: ".sidepanel-relationship-left-label" },
    parentEntity.get('_id').toString() + index.toString(), /*#__PURE__*/

    _jsx("div", { className: "sidepanel-relationship" }, void 0,
    renderLabel(template, relationTypes),
    createRightRelationshipGroups(hub.get('rightRelationships'), props, expanded))));



};

const LibraryViewRelationshipsComp = (props) => {
  const { hubs, searchResults, parentEntity, parseResults } = props;

  useEffect(() => {
    if (parentEntity) {
      parseResults(searchResults, parentEntity, false);
    }
  }, [searchResults, parentEntity]);
  return /*#__PURE__*/(
    React.createElement(React.Fragment, null, /*#__PURE__*/
    _jsx("div", { className: "sidepanel-relationships" }, void 0,
    parentEntity &&
    hubs.map((hub, index) => createLabelGroups(props, hub, index))), /*#__PURE__*/

    _jsx(LoadMoreRelationshipsButton, {}), /*#__PURE__*/
    _jsx(RelationshipMetadata, {})));


};

LibraryViewRelationshipsComp.defaultProps = {
  expanded: true
};

const LibraryViewRelationships = connector(LibraryViewRelationshipsComp);

export { LibraryViewRelationshipsComp, LibraryViewRelationships };